module.exports = __webpack_public_path__ + "static/media/checked-icon-red.da1d4c12.svg";